export default function Spinner() {
    return (
        <div className="flex justify-center py-4">
            <div className="w-8 h-8 border-4 border-blue-500 rounded-full"></div>
        </div>
    );
}